export const STYLES = [
    {
        id: "ghibli",
        title: "Whimsidream",
        description: "Turn your photos into whimsical artwork",
        before: "/examples/ghibli-before.webp",
        after: "/examples/ghibli-after.webp",
        prompt: "Create a studio ghibi version of the image",
        tags: [
            "ghibli art",
            "ghibli style",
            "studio ghibli",
            "studio ghibli style",
            "studio ghibli art",
            "ai ghibli",
            "ai ghibli style",
            "ai ghibli art",
            "whimsidream",
            "whimsidream style",
            "whimsidream art",
            "ai whimsy",
            "ai whimsy style",
            "ai whimsy art",
            "ai whimsy photography",
        ],
    },
    {
        id: "anime",
        title: "Anime",
        description: "Turn your photos into anime artwork",
        before: "/examples/anime-before.webp",
        after: "/examples/anime-after.webp",
        prompt: "Create an anime version of the image",
        tags: [
            "anime",
            "anime style",
            "anime art",
            "ai anime",
            "ai anime style",
            "ai anime art",
        ],
    },
    {
        id: "cartoon-avatar",
        title: "Cartoon Avatar",
        description: "Turn your photos into cartoon avatar style artwork",
        before: "/examples/cartoon-avatar-before.webp",
        after: "/examples/cartoon-avatar-after.webp",
        prompt: "Turn this person into a stylized 3D cartoon character. Use smooth, clay-like textures and soft, matte lighting. Make the head large and rounded, noticeably bigger than the body for a cute, cartoonish proportion. Keep facial features expressive but simplified: large eyes, thick eyebrows, small nose, and a friendly, closed-mouth smile. Match their hairstyle and facial hair in a clean, sculpted style. Use a soft neutral background and a Pixar/DreamWorks-inspired render with high attention to detail and personality. Remove any blemishes or imperfections on the skin. The overall style should feel playful, clean, and high-quality.",
        tags: [
            "cartoon avatar",
            "cartoon avatar style",
            "cartoon avatar art",
            "ai cartoon avatar",
            "ai cartoon avatar style",
            "ai cartoon avatar art",
            "cartoon avatar",
            "ai avatar",
            "ai avatar style",
            "ai avatar art",
            "ai logo",
            "ai logo style",
            "ai logo art",
        ],
    },
    {
        id: "lego",
        title: "Brick",
        description: "Turn your photos into brick artwork",
        before: "/examples/lego-before.webp",
        after: "/examples/lego-after.webp",
        prompt: "Create a lego version of the image",
        tags: [
            "lego",
            "lego style",
            "lego art",
            "ai lego",
            "ai lego style",
            "ai lego art",
        ],
    },
    {
        id: "powerpuff",
        title: "Powercuties",
        description: "Turn your photos into Powercuties artwork",
        before: "/examples/powerpuff-before.webp",
        after: "/examples/powerpuff-after.webp",
        prompt: "Create a powerpuff girls version of the image",
        tags: [
            "powerpuff",
            "powerpuff style",
            "powerpuff art",
            "ai powerpuff",
            "ai powerpuff style",
            "ai powerpuff art",
        ],
    },
    {
        id: "muppet",
        title: "Puppitz",
        description: "Turn your photos into Puppitz style artwork",
        before: "/examples/muppet-before.webp",
        after: "/examples/muppet-after.webp",
        prompt: "Create a muppet version of the image",
        tags: [
            "muppet",
            "muppet style",
            "muppet art",
            "ai muppet",
            "ai muppet style",
            "ai muppet art",
        ],
    },
    {
        id: "popfigurines",
        title: "PopFigurines",
        description: "Turn your photos into PopFigurines style artwork",
        before: "/examples/popfigurines-before.webp",
        after: "/examples/popfigurines-after.webp",
        prompt: "Create a funko pop set from the image. No original image should be visible on the funko pop set.",
        tags: [
            "pop figurines",
            "pop figurines style",
            "pop figurines art",
            "ai pop figurines",
            "funko pop",
            "funko pop style",
            "funko pop art",
            "ai funko pop",
        ],
    },
    {
        id: "familyguy",
        title: "FamDude",
        description: "Turn your photos into FamDude style artwork",
        before: "/examples/familyguy-before.webp",
        after: "/examples/familyguy-after.webp",
        prompt: "Create a family guy version of the image",
        tags: [
            "family guy",
            "family guy style",
            "family guy art",
            "ai family guy",
        ],
    },
    {
        id: "rickandmorty",
        title: "Mortish",
        description: "Turn your photos into Mortish style artwork",
        before: "/examples/rickandmorty-before.webp",
        after: "/examples/rickandmorty-after.webp",
        prompt: "Create a rick and morty version of the image",
        tags: [
            "rick and morty",
            "rick and morty style",
            "rick and morty art",
            "ai rick and morty",
        ],
    },
    {
        id: "shinchan",
        title: "Shin-chan",
        description: "Turn your photos into Shin-chan style artwork",
        before: "/examples/shinchan-before.webp",
        after: "/examples/shinchan-after.webp",
        prompt: "Create a shin-chan version of the image",
        tags: ["shin-chan", "shin-chan style", "shin-chan art", "ai shin-chan"],
    },
    {
        id: "cyberpunk",
        title: "NeoCyber",
        description: "Turn your photos into NeoCyber style artwork",
        before: "/examples/cyberpunk-before.webp",
        after: "/examples/cyberpunk-after.webp",
        prompt: "Create a cyberpunk anime version of the image",
        tags: ["cyberpunk", "cyberpunk style", "cyberpunk art", "ai cyberpunk"],
    },
    {
        id: "adventuretime",
        title: "QuestyToon",
        description: "Turn your photos into QuestyToon style artwork",
        before: "/examples/adventuretime-before.webp",
        after: "/examples/adventuretime-after.webp",
        prompt: "Create a adventure time version of the image",
        tags: [
            "adventure time",
            "adventure time style",
            "adventure time art",
            "ai adventure time",
        ],
    },
    {
        id: "gorillaz",
        title: "G-Rillaz",
        description: "Turn your photos into G-Rillaz style artwork",
        before: "/examples/gorillaz-before.webp",
        after: "/examples/gorillaz-after.webp",
        prompt: "Create a gorillaz version of the image",
        tags: ["gorillaz", "gorillaz style", "gorillaz art", "ai gorillaz"],
    },
    {
        id: "minecraft",
        title: "Pixel blocks",
        description: "Turn your photos into Pixel blocks style artwork",
        before: "/examples/minecraft-before.webp",
        after: "/examples/minecraft-after.webp",
        prompt: "Create a minecraft style version of the image",
        tags: [
            "minecraft",
            "minecraft style",
            "minecraft art",
            "ai minecraft",
            "minecraft blocks",
            "minecraft image",
            "minecraft ai",
            "pixel blocks",
            "pixel blocks style",
            "pixel blocks art",
            "ai pixel blocks",
        ],
    },
    {
        id: "cockroachiez",
        title: "Cockroachiez",
        description: "Turn your photos into Cockroachiez style artwork",
        before: "/examples/cockroachiez-before.webp",
        after: "/examples/cockroachiez-after.webp",
        prompt: "Create a oggy and the cockroaches version of the image",
        tags: [
            "cockroachiez",
            "cockroachiez style",
            "cockroachiez art",
            "ai cockroachiez",
        ],
    },
    {
        id: "manga",
        title: "Manga",
        description: "Turn your photos into manga artwork",
        before: "/examples/manga-before.webp",
        after: "/examples/manga-after.webp",
        prompt: "Create a manga version of the image",
        tags: [
            "manga",
            "manga style",
            "manga art",
            "ai manga",
            "ai manga style",
            "ai manga art",
        ],
    },
    {
        id: "thesimpsons",
        title: "Simpsville",
        description: "Turn your photos into Simpsville style artwork",
        before: "/examples/thesimpsons-before.webp",
        after: "/examples/thesimpsons-after.webp",
        prompt: "Create a simpsons version of the image",
        tags: [
            "the simpsons",
            "the simpsons style",
            "the simpsons art",
            "ai the simpsons",
        ],
    },
    {
        id: "chibi",
        title: "Chibi",
        description: "Turn your photos into Chibi style artwork",
        before: "/examples/chibi-before.webp",
        after: "/examples/chibi-after.webp",
        prompt: "Create a cute chibi version of the image",
        tags: ["chibi", "chibi style", "chibi art", "ai chibi"],
    },
    {
        id: "pixar",
        title: "Pixy",
        description: "Turn your photos into Pixy style artwork",
        before: "/examples/pixar-before.webp",
        after: "/examples/pixar-after.webp",
        prompt: "Create a pixar version of the image",
        tags: ["pixar", "pixar style", "pixar art", "ai pixar"],
    },
    {
        id: "avatar",
        title: "Avatar",
        description: "Turn your photos into Avatar style artwork",
        before: "/examples/avatar-before.webp",
        after: "/examples/avatar-after.webp",
        prompt: "Create an avatar version of the image",
        tags: ["avatar", "avatar style", "avatar art", "ai avatar"],
    },
    {
        id: "comicbook",
        title: "Comicbook",
        description: "Turn your photos into comicbook artwork",
        before: "/examples/comicbook-before.webp",
        after: "/examples/comicbook-after.webp",
        prompt: "Create a comicbook version of the image",
        tags: ["comicbook", "comicbook style", "comicbook art", "ai comicbook"],
    },
    {
        id: "caricature",
        title: "Caricature",
        description: "Turn your photos into caricature artwork",
        before: "/examples/caricature-before.webp",
        after: "/examples/caricature-after.webp",
        prompt: "Create a caricature version of the image",
        tags: [
            "caricature",
            "caricature style",
            "caricature art",
            "ai caricature",
        ],
    },
];
